import { createStore } from '@stencil/store';

export interface MySworkitState {
  activeSegment: 'workouts' | 'steps' | 'assessments';
  prefersDark: boolean
}
const { state } = createStore<MySworkitState>({
  activeSegment: 'workouts',
  prefersDark: window.matchMedia('(prefers-color-scheme: dark)')?.matches

});

const swMySworkitState = state;
export default swMySworkitState;
